const WORKLOAD_LEVELS = new Set(["low", "medium", "high"]);

export const canonicalWorkloadLevel = (workload) => (
  WORKLOAD_LEVELS.has(workload?.level) ? workload.level : null
);

export const workloadTone = (workload) => {
  const level = canonicalWorkloadLevel(workload);
  if (level === "low") return "var(--pc-score-good)";
  if (level === "medium") return "var(--pc-score-medium)";
  if (level === "high") return "var(--pc-score-poor)";
  return "var(--pc-muted)";
};
